export const list = (dispatch, apiClient, query, skipId) =>
  apiClient
    .call({ endpoint: 'bundle/list', data: { query, skipId } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'BUNDLES_SET', payload: res.data.results });
      return res;
    });

export const get = (dispatch, apiClient, id) =>
  apiClient.call({ endpoint: 'bundle/get', data: { id } }).then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'BUNDLES_SET', payload: res.data });
    return res;
  });

export const create = (dispatch, apiClient, data) =>
  apiClient.call({ endpoint: 'bundle/new', data }).then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'BUNDLES_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, data) =>
  apiClient
    .call({ endpoint: 'bundle/update', data: { ...data, id } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'BUNDLES_SET', payload: res.data });
      return res;
    });

export const remove = (dispatch, apiClient, id) =>
  apiClient.call({ endpoint: 'bundle/remove', data: { id } }).then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'BUNDLES_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/bundles.js